import styled from 'styled-components/native';

import { moderateScale } from '../../../../../utils/scaleHelpers';

export const ContentContainer = styled.View`
  padding-bottom: ${moderateScale(10)}px;
  padding-top: ${({ $noMargin }) => $noMargin ? '0' : `${moderateScale(10)}px`};

`;
